import React, { useState, useEffect } from 'react';
import { getDocs } from '../services/api';
import './Home.css';

const TIPO_ICON = { Fatura: '🧾', Recibo: '📄', Contrato: '📋', Documento: '📁' };
const EMPRESA_CLASS = { PP: 'pp', BA: 'ba', PA: 'pa', MA: 'ma' };

export default function Home({ user, onScan }) {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs({ limite: 10 })
      .then(res => setDocs(res.data.docs || []))
      .catch(() => setDocs([]))
      .finally(() => setLoading(false));
  }, []);

  const formatBytes = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    return (bytes / 1024).toFixed(0) + ' KB';
  };

  const formatData = (dateStr) => {
    const d = new Date(dateStr);
    const hoje = new Date();
    const diff = Math.floor((hoje - d) / 86400000);
    if (diff === 0) return 'hoje';
    if (diff === 1) return 'ontem';
    return d.toLocaleDateString('pt-PT', { day: 'numeric', month: 'short' });
  };

  return (
    <div className="home-page">
      <div className="home-hero">
        <div className="home-greeting">
          <span>Olá, {user?.nome?.split(' ')[0] || 'utilizador'} 👋</span>
        </div>
        <button className="scan-main-btn" onClick={onScan}>
          <span className="scan-btn-icon">◎</span>
          Novo scan
        </button>
      </div>

      <div className="home-section">
        <div className="section-header">
          <span className="section-label">Recentes</span>
        </div>

        {loading && (
          <div className="docs-empty">A carregar...</div>
        )}

        {!loading && docs.length === 0 && (
          <div className="docs-empty">
            <span style={{fontSize:'32px'}}>🕊</span>
            <p>Ainda sem documentos.<br/>Faz o primeiro scan!</p>
          </div>
        )}

        <div className="doc-list">
          {docs.map((doc, i) => (
            <div className="doc-item" key={i}>
              <div className="doc-icon-wrap">
                <span>{TIPO_ICON[doc.tipo] || '📁'}</span>
              </div>
              <div className="doc-meta">
                <div className="doc-name">{doc.nome}</div>
                <div className="doc-sub">{formatBytes(doc.tamanho)} · {formatData(doc.data)}</div>
              </div>
              <span className={`empresa-tag ${EMPRESA_CLASS[doc.empresa] || 'pp'}`}>
                {doc.empresa}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
